var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLetter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 15,
  viewBox: "0 0 21 15"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F3D24F",
  d: "M21 13c0 1-1 2-2 2H2c-.817 0-2-1-2-2V2C0 1 1 .011 2 .011h17C20 .011 21 1 21 2v11z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E9BC3E",
  d: "M2.976.927L2 0C1 0 0 1 0 2v11c0 1 1 2 2 2l8-8.542L2.976.927zm15.048 0L19 0c1 0 2 1 2 2v11c0 1-1 2-2 2l-8-8.542L18.024.927z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9E98C",
  d: "M13 8c1.5-1 8-6 8-6 0-1-1-2-2-2H2C1 0 0 1 0 2c0 0 6.622 5.081 8 6 1.5 1 3.5 1 5 0z"
}))));
export default SvgLetter;